import { usePermission } from '@/hooks/usePermission';
import { useAuth } from './use-auth';
import { useIsExternalUser } from './useIsExternalUser';

export const useRolePermissions = () => {
  const { currUser = {} } = useAuth();
  const {
    outreach_enabled = false,
    circles_enabled = false,
    role: currUserRole,
    id: currUserId,
    email,
    is_super_admin = false,
  } = currUser;

  const isExternalUser = useIsExternalUser();
  const showOutreach =
    usePermission({ permission: 'outreach.show?' }) &&
    outreach_enabled &&
    currUserRole !== 'employee';
  const showCircles = circles_enabled;
  const showContacts = circles_enabled || showOutreach;
  const showAllNotifications = showOutreach && showCircles;
  const isJobsVisible = usePermission({
    permission: 'api_ats_v1_ats_job.index?',
  });
  const showJobs = isJobsVisible;
  const showAllSearch = showOutreach && showContacts && showJobs;
  const showReviewAction =
    ['owner', 'admin', 'recruiter'].includes(currUserRole) || is_super_admin;
  const isOwnerOrAdminOrRecruiter =
    ['owner', 'admin', 'recruiter'].includes(currUserRole) && !isExternalUser;
  const isRecruiterAbove = ['owner', 'admin', 'recruiter'].includes(
    currUserRole
  );

  return {
    showOutreach,
    showAllSearch,
    showAllNotifications,
    showContacts,
    showCircles,
    showReviewAction,
    isOwnerOrAdminOrRecruiter,
    isRecruiterAbove,
    currUserId,
    email,
    currUserRole,
    showJobs,
  };
};

export default useRolePermissions;

// note: all the roles that we are currently having in kula
// owner
// admin
// recruiter
// finance_manager
// recruiting_coordinator
// hiring_manager
// employee
// outreach_view
// external_collaborator
